var $82b9f6f0affe6de6$exports = {};
const $82b9f6f0affe6de6$var$RELEASE_AT = Date.parse("2026-11-16T15:00:00+01:00");
function $82b9f6f0affe6de6$var$initializeReleaseTeaser() {
    const teaser = document.querySelector(".release-teaser");
    const heading = teaser.querySelector("#release-heading");
    const countdown = teaser.querySelector(".release-countdown");
    const fallback = teaser.querySelector(".release-fallback");
    const units = [
        "days",
        "hours",
        "minutes",
        "seconds"
    ].map((unit)=>teaser.querySelector(`[data-release-unit="${unit}"]`));
    let timeoutId;
    function updateCountdown() {
        window.clearTimeout(timeoutId);
        const remainingMilliseconds = $82b9f6f0affe6de6$var$RELEASE_AT - Date.now();
        if (remainingMilliseconds <= 0) {
            countdown.hidden = true;
            heading.textContent = "Pl\xe1novan\xfd term\xedn je tu.";
            fallback.hidden = false;
            return;
        }
        const remainingSeconds = Math.ceil(remainingMilliseconds / 1000);
        const values = [
            Math.floor(remainingSeconds / 86400),
            Math.floor(remainingSeconds % 86400 / 3600),
            Math.floor(remainingSeconds % 3600 / 60),
            remainingSeconds % 60
        ];
        units.forEach((element, index)=>{
            const value = String(values[index]).padStart(2, "0");
            if (element.textContent !== value) element.textContent = value;
        });
        countdown.hidden = false;
        timeoutId = window.setTimeout(updateCountdown, Math.min(1000, remainingMilliseconds));
    }
    function handleVisibilityChange() {
        if (!document.hidden) updateCountdown();
    }
    document.addEventListener("visibilitychange", handleVisibilityChange);
    updateCountdown();
}
$82b9f6f0affe6de6$var$initializeReleaseTeaser();


//# sourceMappingURL=repo.a32d9a3c.js.map
